import { gql } from '@apollo/client'

export default gql(`
query batchGetResolutions($input: [ID]){
    batchGetResolutions(
        input: $input
    ){
        id
        key
        height
        width
    }
}`)
